import parser from './parser';

const name = 'tree';

export default {parser, name};
